import { node } from "~/util/dom";
import createSDSIcon from "~/ui/icon";
import { FILE_DOCUMENT_24, TRASH_FILLED_24 } from "@sznds/icons";
import ReportFormField from "./index";
import ReportFormFileloader from "./fileloader";
import ReportFormImage from "./image";
import { ICommonOpts } from "~/report/interfaces";

interface IOpts extends ICommonOpts {
	label?: string;
	sublabel?: string;
	text?: string;
	onChange: (file: File) => void;
}

export default class ReportFormFieldLoader extends ReportFormField {
	#opts: IOpts;

	#loaderNode: HTMLElement;

	#fileloader: ReportFormFileloader;

	#fileNode: HTMLElement;

	#fileNameNode: HTMLElement;

	#fileDeleteNode: HTMLElement;

	constructor(opts: IOpts) {
		super(opts);
		this.#opts = {
			onChange: () => { /**/ },
			label: "",
			sublabel: "",
			text: "",
			icon: null,
			...opts,
		};
		this.#build();
	}

	#build() {
		const { label, sublabel, text, icon: iconNode } = this.#opts;

		const labelNode = node("div", { className: "label" });

		labelNode.innerHTML = `<strong>${label}</strong> ${sublabel || ""}`;

		this.#loaderNode = node("div", { className: "attachment" });

		this.#fileloader = new ReportFormFileloader({
			parent: this.#loaderNode,
			icon: iconNode,
			textMaximal: text,
			isMaximized: true,
			onChange: files => {
				this.#addFile(files);
			},
		});

		const fileIconNode = createSDSIcon({ symbol: FILE_DOCUMENT_24, className: "file-icon" });
		const trashIconNode = createSDSIcon({ symbol: TRASH_FILLED_24, className: "trash" });

		this.#fileNode = node("div", { className: "file hidden" });
		this.#fileNameNode = node("i", { className: "file-name" });
		this.#fileDeleteNode = node("button", { type: "button", className: "file-delete-btn" });

		this.#fileDeleteNode.append(trashIconNode);
		this.#fileDeleteNode.addEventListener("click", this.#removeFile.bind(this));

		this.#fileNode.append(fileIconNode, this.#fileNameNode, this.#fileDeleteNode);
		this.#loaderNode.append(this.#fileNode);
		super.container.append(labelNode, this.#loaderNode);
	}

	#removeFile() {
		this.#fileNode.classList.add("hidden");
		this.#fileloader.show();
		this.#opts.onChange(null);
	}

	#addFile(files: Array<File>) {
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		const { mimeTypes = Mapy.ImageUploader.MIME_TYPES } = this.#opts;
		const file = files[0];

		this.#fileloader.hide();

		if (mimeTypes.includes(file.type)) {
			const photo = new ReportFormImage({
				file,
				parent: this.#loaderNode,
				onDomChange: () => { /**/ },
				onRemove: this.#removeFile.bind(this),
				upload: () => Promise.resolve(file),
				minWidth: 0,
				minHeight: 0,
			});

			photo.settingFile
				.then(() => {
					this.#opts.onChange(file);
				})
				.catch(() => {
					this.#removeFile();
				});
		} else {
			this.#fileNameNode.innerText = file.name;
			this.#fileNode.classList.remove("hidden");
		}
		this.#opts.onChange(file);
	}
}
